module.exports = __webpack_public_path__ + "img/504.52b44f26.jpg";